import {ChangeDetectorRef, Component, Input, OnChanges, OnInit, ViewEncapsulation, EventEmitter, Output } from '@angular/core';
import { Product } from '@app/core/business/product/product';
import { environment } from '@env/environment';
import { ProductService } from '@app/core/business/product/product.service';
import { ContextService } from '@app/core/service/context.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { PriceListType } from '@app/core/business/price-list-type.enum';
import { User } from '@app/core/business/user/user';
import { FavoriteService } from '@app/core/business/product/favorite.service';
import { ElasticSearchService } from '@app/core/business/elastic-search/elastic-serch.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ContactService } from '@app/core/business/contact/contact.service';
@UntilDestroy() 
@Component({
  selector: 'app-product-card',
  templateUrl: './product-card.component.html',
  styleUrls: ['./product-card.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ProductCardComponent implements OnInit, OnChanges {
  @Input()
  product: Product;
  @Input()
  isNetPrice: boolean = true;
  @Input()
  activePriceListType = PriceListType.Net;

  @Output()
  favoriteChange: EventEmitter<string> = new EventEmitter<string>();

  user: User;

  public favoriteLock = false;
  public image: SafeStyle;
  public environment = environment;
  public isVitafrais = false;
  public displayScore = false;

  constructor(private changeDetector: ChangeDetectorRef,
              private productService: ProductService,
              private contextService: ContextService,
              private contactService: ContactService,
              private translate: TranslateService,
              private toastrService: ToastrService,
              private sanitizer: DomSanitizer,
              public favoriteService: FavoriteService, 
              private elasticSearchService: ElasticSearchService
              ) {}

  ngOnInit() {
    if (this.product.score) 
    this.product.score = (+this.product.score).toFixed(2);
    this.elasticSearchService.getUseDisplayScoreElk$()
    .pipe(untilDestroyed(this))
    .subscribe(value => {
      this.displayScore = value;
    });



    if (this.product && this.product.pictures && this.product.pictures[0]) {
      this.image = this.sanitizer.bypassSecurityTrustStyle(
        `url(${environment.baseFileUrl + this.product.pictures[0].url})`
      );
    }

    this.loadPriceListType();

    if (this.contextService.fullContext.company?.code == "VITAFRAIS") {
      this.isVitafrais = true;
    }
  }

  ngOnChanges() {
    this.changeDetector.detectChanges();

    this.loadPriceListType();
  }

  public async setFavorite() {
    if (!this.favoriteLock) {
      // Activate lock to prevent favorite request before the first request finished
      this.favoriteLock = true;


      await this.favoriteService.addFavorite(this.product.code, !this.product.isFavorite);
      this.toastrService.success(
        this.translate.instant(
          this.product.isFavorite
            ? 'product.removeFavorite'
            : 'product.addFavorite'
        ), null, { timeOut: 2000 }
      );

      this.product.isFavorite = !this.product.isFavorite;
      this.product = JSON.parse(JSON.stringify(this.product));

      this.favoriteChange.emit(this.product.code);
      this.favoriteLock = false;
      this.changeDetector.markForCheck();

    }
  }

  /** A remonter dans le contexte si possible pour des raisons de performances */
  private loadPriceListType() {
    this.activePriceListType = this.contextService.context.activePriceListType;
  }
}
